import React from 'react';
import './Table.scss';

const Table = ({ columns, data, loading = false, pagination = null }) => {
    if (loading) return <div className="table-loading">Loading data...</div>;
    if (!data || data.length === 0) return (
        <div className="table-wrapper">
            <table className="admin-table">
                <thead>
                    <tr>{columns.map(col => <th key={col.field || col.header}>{col.header}</th>)}</tr>
                </thead>
                <tbody>
                    <tr><td colSpan={columns.length} className="table-empty" style={{textAlign:'center',padding:'48px',color:'#9ca3af'}}>No data found</td></tr>
                </tbody>
            </table>
        </div>
    );

    const totalPages = pagination?.totalPages || 1;
    const currentPage = pagination?.currentPage || 1;

    const getPageNumbers = () => {
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
        const pages = [1];
        if (currentPage > 3) pages.push('...');
        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) pages.push(i);
        if (currentPage < totalPages - 2) pages.push('...');
        pages.push(totalPages);
        return pages;
    };

    return (
        <div className="table-wrapper">
            <table className="admin-table">
                <thead>
                    <tr>{columns.map(col => <th key={col.field || col.header}>{col.header}</th>)}</tr>
                </thead>
                <tbody>
                    {data.map((row, idx) => (
                        <tr key={row.id || idx}>
                            {columns.map(col => (
                                <td key={col.field || col.header}>
                                    {col.render ? col.render(row, idx) : row[col.field]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            {pagination && (
                <div className="pagination">
                    <span className="pagination-info">
                        Page {currentPage} of {totalPages}
                    </span>
                    <div className="pagination-controls">
                        <button
                            className="page-btn"
                            onClick={() => pagination.onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >←</button>
                        {getPageNumbers().map((p, i) =>
                            p === '...'
                                ? <span key={`e${i}`} className="page-ellipsis">…</span>
                                : <button
                                    key={p}
                                    className={`page-btn ${p === currentPage ? 'active' : ''}`}
                                    onClick={() => pagination.onPageChange(p)}
                                >{p}</button>
                        )}
                        <button
                            className="page-btn"
                            onClick={() => pagination.onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >→</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Table;
